module.exports = __webpack_public_path__ + "img/newyear_title2.21e9e0cd.png";